import { Component } from '@angular/core';
import {Field} from "../../models/field.model";

@Component({
  selector: 'tig-form-timepicker',
  templateUrl: './form-timepicker.component.html',
  styleUrls: ['./form-timepicker.component.scss']
})
export class FormTimepickerComponent extends Field {

	setTime(event: any)
	{
		super.setValue(event);

	}

	/**
	 * @desc Um Zeit auch wieder loeschen zu koennen, muss geprueft werden ob User es manuell rausgeloescht hat.
	 * Um missbrauch zu vermeiden wird nur ein leerer String durchgelassen, "echte" Zeit muss via Timepicker gesetzt werden
	 * @param event
	 */
	checkClearTime(event: any)
	{
		if(event.target.value !== undefined && event.target.value === "")
		{
			this.OBJ_field_config.value = null;
		} // end if

	}
}
